import { Injectable } from '@angular/core';
import { localStorageAccessConstant } from 'src/app/constants/LocalStorageAccessConstant';
import { StorageService } from 'src/app/services/security/storage.service';

@Injectable({
  providedIn: 'root'
})
export class StringHelperService {

constructor(private ls: StorageService) { }
    getNumberInputStepDefaultValue(){
    let decimalPrecision = Number(this.ls.get(localStorageAccessConstant.decimalPrecision));
    if (!Number.isFinite(decimalPrecision) || decimalPrecision < 1)
        decimalPrecision = 4;
    return "0." + "0".repeat(decimalPrecision - 1) + "1";
    }
}
